<template>
<div class="chapter">
<div class="inner_page">
<p class="C1094"><big><em><span id="page_1">In </span>Line for the Exterminator </em></big></p>
<p class="C1098">a dark ride at Kennywood Park, Pittsburgh </p>
<p class="C1100">Four skinheads swear and sweat </p>
<p class="C1104">in fat leather behind my son and me </p>
<p class="C1104">looping around endless rows of steel rails </p>
<p class="C1104">in the fake cinderblock bunker. The ride </p>
<p class="C1104">simulates a trip through the bowels of sewers </p>
<p class="C1104">beneath the city. The skinny punks who cut in line </p>
<p class="C1104">jokingly press the “panic button,” a blaring echo </p>
<p class="C1104">that mimics nightmare alarms. They won’t stop </p>
<p class="C1104">though somebody’s shouting <em>stop it. </em>Some young blacks </p>
<p class="C1104">with their girlfriends throw scowls at the skinheads. </p>
<p class="C1104">Perfume and deodorant and farts and spit and melting make-up </p>
<p class="C1104">and exposed skin pierced or not and tattoos and thick jewelry </p>
<p class="C1104">and tight clothing plastered against skin of all colors. </p>
<p class="C1104">My son is glassy-eyed with the room’s menace—</p>
<p class="C1104">it stings. It clings. The line crawls like a whipped dog </p>
<p class="C1104">toward the dark door behind which it’s promised </p>
<p class="C1104">we are all to be scared. A fake newscaster on a monitor </p>
<p class="C1104">describes a power failure. I want to ask “How many </p>
<p class="C1104">in this room make minimum wage? How many </p>
<p class="C1104">in this room will ever own a house? </p>
<p class="C1104">What if we all made a giant wad of gum </p>
<p class="C1104">and rolled it out of this park and onto the front lawn </p>
<p class="C1104">of the richest motherfucker in this city?” </p>
<p class="C1104"><span id="page_2">We </span>have all paid our admission and had our hands </p>
<p class="C1104">stamped. Perhaps the walls are </p>
<p class="C1104">closing in on us. “Hey, how many of you </p>
<p class="C1104">have been on this ride before?” </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_1_In_Lin.vue?5806b0e2